module.exports = __webpack_public_path__ + "img/naka.872c99ca.svg";